module.exports = __webpack_public_path__ + "img/psychology.013a888c.png";